module.exports = __webpack_public_path__ + "static/media/platforms.49df30cd.svg";